import React, { useEffect, useState } from 'react';
import xBlack from '../../../assets/xBlack.svg';
import { RxText } from 'react-icons/rx';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import './reportTools.scss';
import { allDropableID, defaultDashboardSchema } from '../../../data/defaultSchema';
import { mls } from 'lib/multilanguagesupport';
const { reportToolsId } = allDropableID;
const ReportTools = ({ reportTools, setReportTools }: mainPorps) => {
  // useEffect(() => {
  //   if (reportTools.length === 0) {
  //     setReportTools([defaultDashboardSchema.reportTools]);
  //   }
  // }, [reportTools, setReportTools]);

  return (
    <Droppable droppableId={reportToolsId} key={reportToolsId}>
      {(provided, snapshot) => (
        <div className='sectionContainer' ref={provided.innerRef}>
          {/* {reportTools.length === 0 && <div className='sectionItem noSection'>No reportTools</div>} */}
          {React.Children.toArray(
            reportTools.map((elm: { title: string; icon: any }, index: number) => (
              <>
                <ToolItem targetElem={elm} index={index} />
              </>
            ))
          )}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default ReportTools;

interface toolItemPorps {
  targetElem: {
    title: string;
    icon: any;
  };
  index: number;
}

const ToolItem = ({ targetElem, index }: toolItemPorps) => {
  return (
    <>
      <Draggable
        key={`${index}`}
        draggableId={`${reportToolsId.toString() + index.toString()}`}
        index={index}
        //   isDragDisabled={checked}
      >
        {(provided, snapshot) => {
          const Icon = targetElem.icon;
          return (
            <div
              className='sectionItem'
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              <div className='icon'>
                <Icon />
              </div>
              <div>{mls(targetElem.title)}</div>
            </div>
          );
        }}
      </Draggable>
    </>
  );
};

interface mainPorps {
  reportTools: any[];
  setReportTools: Function;
}
